import { computed, type Ref, ref } from 'vue';

const DISMISSED_PROFILE_AT_KEY = 'insightRegenerateBannerDismissedProfileAt';

// 再生成バナーを「閉じる」で消したときのプロフィール更新時刻を保存する。
// プロフィールが更新されて updated_at が変われば保存値と一致しなくなり、再表示される。
export const useInsightRegenerateBannerDismissal = (
  profileUpdatedAt: Ref<string | null | undefined>,
) => {
  const dismissedProfileAt = ref(
    localStorage.getItem(DISMISSED_PROFILE_AT_KEY),
  );

  // 現在のプロフィール更新時刻が、閉じたときに保存した値と一致する間だけ非表示にする
  const isDismissed = computed(() => {
    const current = profileUpdatedAt.value;
    if (current === null || current === undefined) return false;
    return dismissedProfileAt.value === current;
  });

  const dismiss = () => {
    const current = profileUpdatedAt.value;
    if (current === null || current === undefined) return;
    localStorage.setItem(DISMISSED_PROFILE_AT_KEY, current);
    dismissedProfileAt.value = current;
  };

  return { isDismissed, dismiss };
};
